import { useEffect, useState } from "react";
import api from "../lib/api";
import DataTable from "../components/DataTable";
import PageHeader from "../components/PageHeader";
import { Badge, statusVariant } from "../components/Badge";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Payments() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/payment-methods");
    setRows(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const remove = async (row) => {
    if (!window.confirm(`Delete ${row.name}?`)) return;
    await api.delete(`/payment-methods/${row.id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="payments-page">
      <PageHeader title="Payments List" subtitle="Active payment methods across the platform" />
      <DataTable
        testId="payments-table"
        loading={loading}
        rows={rows}
        columns={[
          { key: "name", label: "Name" },
          { key: "type", label: "Type" },
          { key: "account_details", label: "Account Details" },
          { key: "status", label: "Status", render: (r) => <Badge variant={statusVariant(r.status)}>{r.status}</Badge> },
          { key: "created_at", label: "Created", render: (r) => new Date(r.created_at).toLocaleDateString() },
        ]}
        actions={(row) => (
          <button onClick={() => remove(row)} className="h-8 w-8 inline-flex items-center justify-center border border-gray-200 rounded-sm text-gray-500 hover:text-red-600 hover:border-red-200" data-testid={`payments-delete-${row.id}`}>
            <Trash2 size={14} />
          </button>
        )}
      />
    </div>
  );
}
